var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoVolumeOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 25.003,
  height: 25.003,
  fill: "#454A4A",
  fillOpacity: 0.7,
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAFDFF",
  fillRule: "evenodd",
  d: "m11.411 7.429-2.906 2.42H7.17c-.733 0-1.333.6-1.333 1.333v2.667c0 .733.6 1.333 1.333 1.333h1.334l2.906 2.42a.667.667 0 0 0 1.094-.513V7.942c0-.566-.66-.88-1.094-.513m5.074.467a.666.666 0 0 0-.654 1.16 3.97 3.97 0 0 1 2.007 3.46c0 1.433-.767 2.76-2.007 3.46a.666.666 0 0 0 .654 1.16 5.31 5.31 0 0 0 2.686-4.62 5.3 5.3 0 0 0-2.686-4.62m-2.614 2.52c.12-.347.5-.534.847-.414a2.653 2.653 0 0 1 .007 5.02.67.67 0 0 1-.847-.413.67.67 0 0 1 .413-.847c.527-.18.88-.68.88-1.246 0-.567-.353-1.067-.886-1.254a.67.67 0 0 1-.414-.846",
  clipRule: "evenodd"
})));
export default SvgVideoVolumeOn;